var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"117",
      name:"流程建模",
      parentId:"FLOW_ID", 
      parentName:"审批流程定义",
      parentPath:"/system/approvalFlow",
      dataClass:2,
      addClick: _vm.addClick,
    },"filterWhere":{FLOW_ID:_vm.$route.query.FLOW_ID}}}),_c('m-selectorcc',{attrs:{"visible":_vm.select,"select":{
    searchslotType: "",
    searchslottitle: "请选择角色",
    multiple: true,
    searchslotId: 105,
    searchslotkey: { ID: "ID", TEAM_NAME :"TEAM_NAME" },
  }},on:{"update:visible":function($event){_vm.select=$event},"listenEvent":_vm.fn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }